export const MORTGAGE_LINK = 'https://www.cian.ru/ipoteka-main/?utm_medium=country-projects';
